import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';

// Components
import SearchBar from '../../../../Components/Ui/SearchBar';
import WeeklyCalendar from './../ui/WeekCalendar';
import PermitList from '../ui/PermitList';
import WriteFAB from '../ui/WriteFAB';
import FilterBottomSheet from '../ui/FilterBottomSheet';
import Filter from '../ui/Filter';

// Reducers / Actions
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { setSearchText, setDepCd } from '../../../../Reducer/SearchReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import { useBackStack } from '../../../../Hooks/back/useBackStack';

export default function M_PER_NEW(props) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  const searchInfo = useSelector((state) => state.searchInfo);
  const { selectedFilter, filterLabels } = useSelector((state) => state.permit);
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/Home', { replace: true }),
  });
  // 부서 옵션 생성
  const deptOptions = [
    { label: '전체 부서', value: '' },
    ...(searchInfo.depList || []).map((d) => ({
      label: d.name,
      value: d.value,
    })),
  ];

  // 상태 옵션 생성
  const statusOptions = [
    ...(filterLabels || []).map((label) => ({
      label,
      value: label,
    })),
  ];

  // 필터 바에 표시될 아이템
  const filterItems = [
    {
      key: 'dept',
      label: '부서',
      value:
        deptOptions.find((d) => d.value === searchInfo.depCd)?.label ??
        '전체 부서',
    },
    {
      key: 'status',
      label: '상태',
      value: selectedFilter !== '전체' ? selectedFilter : '전체',
    },
  ];

  const filterOptionsByKey = {
    dept: deptOptions,
    status: statusOptions,
  };

  // 필터 선택 핸들러
  const handleFilterSelect = (key, option) => {
    if (key === 'dept') {
      dispatch(setDepCd(option.value));
    } else if (key === 'status') {
      dispatch(PermitActions.setSelectedFilter(option.value || '전체'));
    }
    setTimeout(() => props.SearchLogic1(), 0);
  };

  const handleSearchChange = (e) => {
    dispatch(setSearchText(e.target.value));
  };

  const handleWriteClick = () => {
    dispatch(CommonActions.setActiveStep(1));
    navigate('/M_Permit/write');
  };

  const filteredPermits = (props.rowData1 || []).filter((item) => {
    const matchesStatus =
      selectedFilter === '전체' ? true : item.status === selectedFilter;

    const searchTarget = `${item.reqNm || ''} ${
      item.workContent || ''
    }`.toLowerCase();
    const matchesSearch = searchTarget.includes(
      (searchInfo.searchText || '').toLowerCase()
    );

    return matchesStatus && matchesSearch;
  });

  return (
    <div className="flex flex-col gap-1 px-4 text-base">
      {/* 검색바 */}
      <SearchBar
        searchBarclassName="bg-white"
        className="bg-transparent p-0"
        value={searchInfo.searchText}
        onChange={handleSearchChange}
        placeholder="신청인, 작업 내용"
      />

      {/* 필터바 */}
      <Filter
        className="bg-transparent p-0"
        items={filterItems}
        optionsByKey={filterOptionsByKey}
        onSelect={handleFilterSelect}
      />

      {/* 주간 캘린더 */}
      <WeeklyCalendar
        onDateSelect={props.SearchLogic1}
        refreshClick={props.refreshClick}
      />

      {/* 결과 목록: 필터링된 데이터 전달 */}
      <PermitList data={filteredPermits} SaveLogic1={props.SaveLogic1} />

      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'filter' && (
        <FilterBottomSheet SearchLogic1={props.SearchLogic1} />
      )}

      {/* 작성 FAB */}
      <WriteFAB handleWriteClick={handleWriteClick} />
    </div>
  );
}
